"use client";
import { LicenseInfo } from "@mui/x-license";
 
LicenseInfo.setLicenseKey("8cc026ed80e9db964cd065953a97054aTz0xMjU1MzksRT0xODAyMzkwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");
 
export default function MuiXLicense() {
  return null;
}